module.exports = {
    h32: '32px',
    h40: '40px',
    h48: '48px',
    h56: '56px',
};
